module.exports = __webpack_public_path__ + "pc/static/img/sold_out.59645cc7.png";